import React from "react";

const Badge = ({ data, className }) => {
    if (!data) return null;

    let badgeCss = "";
    if (data.type === "Succeed") badgeCss = "text-green-600 bg-green-50";

    const css = `text-xs py-[3px] px-[5px] inline-block rounded-sm ${badgeCss} ${className}`;

    return <span className={css}>{data.text}</span>;
};

export default Badge;
